import moment from "moment";

export class DateExtensions {
    static onlyDateForServer(datetime?: string): string | null {
        if (datetime) {
            return moment(datetime).format('YYYY-MM-DD');
        }
        return null;
    }
}